module.exports = __webpack_public_path__ + "createstatic/media/btnConnect.bf35dc4e.svg";